export const FEATURES = {
  BLOG: '2019BLOG',
  STORE: '2019EES',
  BOOKING: '2020NAVBOOKING'
}
